import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=033e294e"
import script from "./ClienteForm.vue?vue&type=script&lang=js"
export * from "./ClienteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports